module.exports = __webpack_public_path__ + "assets/img/block-left-f3a346a1.png";